import React, { Component } from 'react'
import Page from './Page'
import { Link } from 'react-router-dom'
import Section, { SECTIONS } from './Section'
import LoadingSpinner from '../generic/LoadingSpinner'
import { Button, ButtonLink, Row, Tip, ReadOnlyText } from '../generic';
import CopyToClipboardButton from '../CopyToClipboardButton';
import * as variables from '../../styles/variables';
import checkRequiredFields from '../../helpers/check-required-fields';
import styled from 'styled-components';

const REQUIRED_FIELDS = [
  "graphic",
  "message",
  "when",
  "where",
  // "signature",
  "rsvp-options",
].map(key => SECTIONS[key].requiredFields).flat()

const LetterContainer = styled.div`
  padding: 10px 10px 1px;
  background-color: ${variables.colours.lightGrey};
  margin-bottom: 25px;
  border-radius: 5px;
`

const Warning = styled.div`
  color: ${variables.colours.orange};
  margin-bottom: 32px;
`

class Event extends Component {
  constructor(props) {
    super(props)
    this.state = {
      canPublish: checkRequiredFields(REQUIRED_FIELDS, this.props.userEvent),
    }
  }

  componentWillMount() {
    this.props.getEvent()
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      canPublish: checkRequiredFields(REQUIRED_FIELDS, nextProps.userEvent),
    })
  }

  handleFocus(event) {
    event.target.select()
  }

  render() {
    let publishPrompt

    const { userEvent, guests } = this.props

    let attendingGuests = [];
    if (guests && guests.length > 0) {
      attendingGuests = guests.filter((guest) => {return guest.status === 'yes';});
    }

    if (!userEvent) {
      return (<LoadingSpinner />)
    }

    if (this.state.canPublish) {
      if (userEvent.published) {
        publishPrompt = <p>Your invitation is live!</p>
      } else {
        publishPrompt = <p>Your invitation is ready! You can get the link to your invitation page in the next step.</p>
      }
    } else {
      publishPrompt = <p>Complete all sections to publish your invitation.</p>
    }

    const eventURL = `${process.env.REACT_APP_BASE_URL}/event/${userEvent.token}`

    return (
      <Page {...this.props}>
        {userEvent && userEvent.cancelled && attendingGuests.length > 0 && <Warning>Your event is listed as cancelled, but you have received RSVPs. Be sure to message all guests to let them know about this change.</Warning>}
        <h1>Build Your Invitation</h1>
        {userEvent.published ? (
          <LetterContainer style={{paddingBottom: '10px'}}>
            <p>Your invitation is published and is viewable here:</p>
            <Row>
              <ReadOnlyText style={{"display": "inline", background: 'white'}} value={eventURL} onFocus={this.handleFocus} />
              <CopyToClipboardButton label="Copy Link" text={eventURL} style={{"display": "inline", "marginLeft": "10px"}} />
            </Row>
          </LetterContainer>
        ) : (
          <Tip id="event-initial">
            <p>Fill out the items below to build your invitation page. Later we will show you how to send people to your invitation page.</p>
          </Tip>
        )}
        <LetterContainer>
          <Section slug="graphic" userEvent={userEvent} />
          <Section slug="message" userEvent={userEvent} />
          <Row className="twoCol">
            <Section slug="when" userEvent={userEvent}/>
            <Section slug="where" userEvent={userEvent}/>
          </Row>
          <Section slug="rsvp-options" userEvent={userEvent} />
        </LetterContainer>
        {publishPrompt}
        <ButtonLink to="/host/hub/dashboard" style={{marginRight: '16px', marginBottom: '16px'}}>{userEvent.published ? "< Go back" : "< Save and finish later"}</ButtonLink>
        {!userEvent.published && <Button disabled={!this.state.canPublish} onClick={this.props.onPublish}>Save and close</Button>}
      </Page>
    )
  }
}

export default Event
